import { ArgumentService } from './../argument/argument.service';
import { Section } from './../argument/argument.model';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONFIG } from './../../../../_config/config';
import { FormGroup } from '@angular/forms';
import { QueryService } from '../query.service';

@Injectable({
  providedIn: 'root'
})
export class DataGridService {

  gateway = this.config.gateway;
  url= `${this.gateway.url}/lbw`;
  urlEscenario = `${this.gateway.urlQuery}/lbw/escenario`;
  urlQuery = `${this.gateway.urlQuery}/lbw`;
  urlDescarga = `${this.gateway.urlQuery}/lbw/descarga`;
  urlProcedimiento = `${this.gateway.urlProcedure}/lbw/procedimiento`;
  urlMacro = `${this.gateway.urlMacro}/lbw/macro`;
  urlReportes = `${this.gateway.urlReport}/lbw/reportes`;
  urlTem: string = `${this.gateway.urlTemplate}/lbw/template`;

  constructor(
    private http: HttpClient,
    private argumentService: ArgumentService,
    private config: CONFIG
  ) { }

  onGetDataGrid(queryid: string, basedonid: string, listArgument: any,
                queryconfigtype, queryHeader: string = '', basedOnHeaderId: string = '', skip, take) {
                 /* if(queryid==='queryAguasDeProduccion' || queryid==='HIST_AguasdeProd'){
                    skip = undefined;
                    take = undefined;
                  }*/
    listArgument = this.mapArgsNoUndefined(listArgument);
    console.log('INICIAL listArgument' , listArgument);
    let argFind = listArgument.find(item => item.argid === "[LOGON_NAME]" );
    if(!argFind){      
      listArgument = this.objectLogoName(listArgument);
      console.log('listArgument' , listArgument);
    }
    let bodyparams = null;
    let type = 'grid';
    let args =  Object.assign ([], listArgument);
    for (let arg of args) {
      if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && arg.argdata !== 'null') {

        if(arg.argdata instanceof Date){
          let date = null;
          let day = "";
          let month = "";
          if (new Date(arg.argdata).getDate() < 10) {
            day = '0' + new Date(arg.argdata).getDate();
          }
          date = new Date(arg.argdata);
          arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()}`;
          arg.argtext = arg.argdata;
        }

      }
    }
    if(queryconfigtype ==='procedure'){
      console.log("Ejecutando query especial TIPO: " , queryconfigtype )
      args = this.mapArgsGridNoUndefined(args); //Estructura como la pide la api de BE
      type = queryconfigtype;
      let logon_name = sessionStorage.getItem('logonName')
      bodyparams = this.armObjectProcedure(queryid, basedonid, take, skip, logon_name, type, args, queryHeader, basedOnHeaderId);
      return this.http.post(`${this.urlProcedimiento}/procedure/data/xlsx`, bodyparams);
    }else if(queryconfigtype !=='special'){
      bodyparams = this.armObject(queryid, basedonid, queryHeader, basedOnHeaderId, type, args, skip, take);
      console.log("parametros de la peticion: " , bodyparams)
      return this.http.post(
         `${this.urlQuery}/consulta/query/data`, 
          bodyparams
         );
    }
  }

  // Rembe
  onGetExportMacroConfig(queryid){
    return this.http.get(`${this.urlMacro}/reporte/macro/loadMacro/${queryid}`, { responseType: "arraybuffer" });
  }

  onGetExportHistPdf(object){
    return this.http.post(`${this.urlTem}/export/historico/document`,object, { responseType: "arraybuffer" });
  }

  onGetDataMacro(queryid: string, args: any){
    args = this.objectLogoName(args);
    args = this.mapArgsGridNoUndefined(args);
    let bodyparams = null;
    for (let arg of args) {
      if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && arg.argdata !== 'null') {

        if(arg.argdata instanceof Date){
          let date = null;
          let day = "";
          let month = "";
          if (new Date(arg.argdata).getDate() < 10) {
            day = '0' + new Date(arg.argdata).getDate();
          }
          date = new Date(arg.argdata);
          arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()}`;
        }

      }
    }

    if(queryid ==='RepBiotecnologiaCombinado'){
      bodyparams = this.armObjectMacro(queryid, 0, 0, 2, args, 'xls');
      return this.http.post(`${this.urlMacro}/reporte/reportPOICombinado`, bodyparams, { responseType: "arraybuffer" });
    }else if(queryid ==='RPTE_SUBMISSION_HIST_JAS' || queryid === 'ReporteXMuestraHist'){
      bodyparams = this.armObjectMacro(queryid, 0, 0, 2, args, 'xls');
      return this.http.post(`${this.urlMacro}/reporte/submissionhistorico`, bodyparams, { responseType: "arraybuffer" });
    }else{
      bodyparams = this.armObjectMacro(queryid, 0, 0, 2, args, 'xlsx');
      return this.http.post(`${this.urlMacro}/reporte/reportPOIExcel`, bodyparams, { responseType: "arraybuffer" });
    }
  }

  armObjectProcedure(queryid, basedonid, take, skip, logonname, sysuserid, args,queryHeader, basedOnHeaderId){
    let bodyparams = {
      "queryId": queryid,
      "basedonId": basedonid,
      "take": take,
      "skip": skip,
      "logonname": logonname,
      "sysuserid": sysuserid,
      "args": args,
      "headerQueryId": queryHeader,
      "headerQueryBasedOnId": basedOnHeaderId
    };
    return bodyparams;
  }

  armObjectMacro(queryid, take, skip, level, args, format){
    let bodyparams = {
      "queryId": queryid,
      "reportName": queryid,
      "format": format,
      "skip": skip,
      "take": take,
      "level":level,
      "arguments": args
    };
    return bodyparams;
  }

  armObject(queryid, basedonid, queryHeader, basedOnHeaderId, type, args, take, skip){
    let bodyparams = {
      "queryId": queryid,
      "basedonId": basedonid,
      "headerQueryId": queryHeader,
      "headerQueryBasedOnId": basedOnHeaderId,
      "type": type,
      "args": args,
      "skip": take,
      "take": skip
    };
    return bodyparams;
  }


  mapArgsGridNoUndefined(args){
    return args.map((item) => ({
      name: item.argid === undefined ? "" : item.argid,
      title: item.argdesc === undefined ? "" : item.argdesc,
      value: item.argdata === undefined ? "" : item.argdata,
      text: item.argtext === undefined ? "" : item.argtext,
    }));
  }

  mapArgsNoUndefined(args){
    return args.map((item) => ({
      argid: item.argid === undefined ? "" : item.argid,
      argdesc: item.argdesc === undefined ? "" : item.argdesc,
      argdata: item.argdata === undefined ? "" : item.argdata,
      argtext: item.argtext === undefined ? "" : item.argtext,
      argtype: item.argtype === undefined ? "" : item.argtype,
    }));
  }



  objectLogoName(args){

    let logoName = {
      "argdata":sessionStorage.getItem('logonName'),
      "argtext": sessionStorage.getItem('logonName'),
      "argid": "[LOGON_NAME]",
      "argdesc": "Usuario",
      "argtype": "string"
    }

    let sysUserId = {
      "argdata":sessionStorage.getItem('sysUserId'),
      "argtext": sessionStorage.getItem('sysUserId'),
      "argid": "[SYSUSERID]",
      "argdesc": "sysUserId",
      "argtype": "string"
    }
    args.push(logoName);
    args.push(sysUserId);
    return args

  }

  onToFormGroup(sections: Section[]): FormGroup {
    return this.argumentService.onToFormGroup(sections);
  }

    /// servicios adicionales
  /// Obtener escenarios de la consulta
  getScenarios(queryid: string, basedonid: string, action = 'query') {
    // obtener escenarios del query seleccionado.

    try {
      // let urlJson = 'assets/data/scenarios.json'; // ruta temporal
      let paramsbody;
      paramsbody = {
        queryid,
        basedonid
      };
      console.log("Escenarios: ", paramsbody);
      return this.http.post(`${this.urlEscenario}/scenario/byquery`, paramsbody);
      // console.log('Solicitud Escenarios');
      // return this.http.get(urlJson);

    } catch (error) {
      console.log('Error scenarios');
    }
  }

  onGetJasperTemplate(object){
    return this.http.post(`${this.urlTem}/export/exporttemplate`, object, { responseType: "arraybuffer" });

  }

  onGetJasper(reportName, arg, format, queryid){
     // args = this.objectLogoName(args);
    arg.LOGON_NAME = sessionStorage.getItem('logonName');
    arg.queryid = queryid;
    const bodyparams = {
      "reportName": reportName,
      "parameters": arg
    };
    console.log('exportJasper' , bodyparams);
    return this.http.post(`${this.urlReportes}/export/${format}`, bodyparams, { responseType: "arraybuffer" });

  }

  onDownloadFile(object){
    return this.http.post(`${this.urlDescarga}/attachment/downloadfile`, object, { responseType: 'blob' as 'json' });
  }

  onDownloadFileICP(object){
   // console.log("parametros de la peticion: " , object)
    object.external = 'ICP';
    return this.http.post(`${this.urlDescarga}/attachment/downloadfile`, object, { responseType: 'blob' as 'json' });
  }

}